import { ScriptManager } from 'lib/scriptManager';
import { create } from 'zustand';

interface ScriptManagerState {
  scriptManager: ScriptManager;
}

export const useScriptManagerStore = create<ScriptManagerState>()(() => ({
  scriptManager: new ScriptManager(),
}));
